import { offeringIsTerminated } from "@equidefi/shared";
import type { DTO } from "@equidefi/shared/types";

/**
 * Whether the issuer can send a reminder ("poke") for an investment.
 *
 * The reminder stays available while the investor still has outstanding
 * countersignature checks, and is disabled once every check is clear
 * (the investment is ready to countersign) or the deal is terminal.
 *
 * Eligibility mirrors the countersign feature via `is_countersignable`
 * (computed server-side by `isAgreementCountersignable`). Because that flag
 * is also `false` for completed/canceled/voided agreements, the terminal
 * states are excluded explicitly via `countersignature_status`.
 */
export const canSendReminder = (investment?: DTO.Investment): boolean => {
  if (!investment) return false;
  if (offeringIsTerminated(investment.offering)) return false;
  if (["CANCELED", "REJECTED", "CLOSED"].includes(investment.status)) return false;
  // Already countersigned ("success") or agreement canceled/voided ("error") — nothing to poke.
  if (["success", "error"].includes(investment.countersignature_status)) return false;
  // Enabled only while outstanding countersign checks remain.
  return !investment.is_countersignable;
};
